import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Taggle from "taggle";
import "../Asociados/createAsociados.css";
import "./createProduct.css";

import { useFormik } from "formik";
import { productoFormValidate } from "../../../../helper/validate";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import "./../formsCommons.css";
// CHECAR import useSearchList, { useFormInput } from "../../../../hooks/custom.hooks";
import stylesPro from "./createProduct.module.css";

import DragNdrop from "../DragnDrop/DragNDrop";
import {
  ImagePathBuilder /*, useTraceUpdate*/,
  onlyNumbers,
} from "helper/tools";
import invalidClass, { formikExtra } from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import { withMask } from "use-mask-input";
import UpDown from "../../../UpDown";

const CreateProduct = forwardRef(({ item, reloadProducto }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();

  const inputRef = useRef();
  const tagRef = useRef();
  const dragDropRef = useRef();

  /// CHECAR  useTraceUpdate(props, "CreateProduct");
  const [files, setFiles] = useState([]);
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    if (item == null || createMode) {
      return;
    }

    tagRef.current?.removeAll();

    // validar que no cree contenedores vacios
    var images = [];
    if (item.productImagePathsString?.length > 0) {
      images = item.productImagePathsString?.split(",");
    }
    const imageURLs = images.map((el) => ImagePathBuilder.to(el));

    setFiles(imageURLs);

    formik?.resetForm();

    let tagList = item.tagsProducto;
    const tags = tagList.map((el) => el.nombre.trim());

    tagRef.current.add(tags);

    //
    /*const myFirstCounter = makeCounter();

    console.log(typeof myFirstCounter);
    // => function

    console.log(myFirstCounter.name);
    // => increment

    myFirstCounter();
    // => 1
    console.log(myFirstCounter());*/
    // => 2
    //
  }, [item]);
  /*
  function makeCounter() {
    let counter = 0;

    // This returns a new function that encloses the local variable counter
    return function increment() {
      counter += 1;
      return counter;
    };
  }*/

  const [marcas, setMarcas] = useState([
    { id: 0, nombre: "Selecciona una Marca..." },
  ]);

  const [generos, setGenero] = useState([
    { id: 0, nombre: "Selecciona un Genero..." }, //tipo de producto..." },
    //  ...Genero,
  ]);

  const [tamaños, setTamaños] = useState([
    { id: 0, nombre: "Selecciona un Tamaño..." },
  ]);

  const [concentraciones, setConcentraciones] = useState([
    { id: 0, nombre: "Selecciona una Concentración..." },
  ]);

  const [presentaciones, setPresentaciones] = useState([
    { id: 0, nombre: "Selecciona una Presentación..." },
  ]);

  /*

  const [categories] = useState([
    { id: 0, nombre: "Selecciona una categoria..." },
    ...CategoriasProducto,
  ]);*/

  //let tags = null;

  const fetchData = async () => {
    const response = await api.marcas().catch((e) => {
      toast.error("Error al pedir usuarios.");
    });
    if (!response) return;

    setMarcas([...marcas, ...response.data]);

    const responseGenero = await api.generos().catch((e) => {
      toast.error("Error al pedir generos.");
    });
    if (!responseGenero) return;

    setGenero([...generos, ...responseGenero.data]);

    const responseTamano = await api.tamaños().catch((e) => {
      toast.error("Error al pedir tamaños.");
    });
    if (!responseTamano) return;

    setTamaños([...tamaños, ...responseTamano.data]);

    const responseConcentracion = await api.concentraciones().catch((e) => {
      toast.error("Error al pedir concentraciones.");
    });
    if (!responseConcentracion) return;

    setConcentraciones([...concentraciones, ...responseConcentracion.data]);

    const responsePresentaciones = await api.presentaciones().catch((e) => {
      toast.error("Error al pedir presentaciones.");
    });
    if (!responsePresentaciones) return;

    setPresentaciones([...presentaciones, ...responsePresentaciones.data]);

    console.log(responsePresentaciones.status);
  };

  useEffect(() => {
    tagRef.current = new Taggle("example1", {
      allowDuplicates: false,
      preserveCase: true,
      inputFormatter: function (input) {
        //input.style.textTransform = "uppercase";

        input.addEventListener("input", (el) => {
          el.currentTarget.value = el.currentTarget.value.trim().toUpperCase();
        });
        return input;
      },
      onTagRemove: function (e, tag) {
        console.log(tag);
      },
      onBeforeTagRemove: function (e, tag) {
        return true;
      },
    });
    tagRef.current.removeAll();
    formik?.resetForm();

    const newPermissions = PermissionsForSection(Sections.Productos);
    setPermissions(newPermissions);

    fetchData();
  }, []);

  let initialValues = {
    id: 0,
    nombre: "",
    descripcion: "",
    tags: "",

    precioCosto: 0,
    precioVenta: 0,
    sku: "",
    codigoBarras: "",
    marcaId: 0,
    generoId: 0,
    tamañoId: 0,
    concentracionId: 0,
    presentacionId: 0,
    productImagePathsString: null,

    activo: true,

    cantidad: 0,

    tagsProducto: [],
  };

  if (!createMode) {
    //const images = item.productImagePathsString?.split(",") ?? [];
    /*images = images.map((el) => ImagePathBuilder.to(el));

    setInsideImages(images);
    */
    //--dragDropRef.current.setSelectedFiles(images);
    //let tags = tagRef.current.getTags().values.split(",");
    //tags = tags.map(el => el.trim());

    /*values.tags = tagRef.current.getTags().values.join(", ");
      tagRef.current.
      array = array.map(el => el.trim());*/

    initialValues = {
      id: item.id,
      nombre: item.nombre,
      descripcion: item.descripcion,
      tags: item.tags,

      precioCosto: item.precioCosto,
      precioVenta: item.precioVenta,
      codigoBarras: item.codigoBarras,
      marcaId: parseInt(item.marca.id),
      generoId: parseInt(item.genero.id),

      tamañoId: parseInt(item.tamaño.id),
      concentracionId: parseInt(item.concentracion.id),
      presentacionId: parseInt(item.presentacion.id),
      sku: item.sku,

      productImagePathsString: item.productImagePathsString,
      activo: item.activo,

      cantidad: item.cantidad,
    };
  }

  //console.log("-->");
  //console.log(initialValues);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: productoFormValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      const tagProductos = tagRef.current.getTags().values.map((value) => ({
        id: 0,
        nombre: value,
      }));

      values.tagsProducto = tagProductos;
      //is - invalid;

      /*
      No enviar “NumProducto”, 
      “CategoriaId”, 
      “PrecioCosto” y 
      “PrecioVenta” en Crear/Editar.
*/
      // TODO: quitar cuando ya se cambie precios inventario
      if (createMode) {
        delete values["precioCosto"];
        delete values["precioVenta"];
      }

      delete values["sku"];

      if (values.id === 0) {
        const toastId = toast.loading("Creando Producto...");
        let response = await api
          .createProducto(values, dragDropRef.current.selectedFiles())
          .catch((e) => {
            toast.dismiss(toastId);
            if (e.esError && e.codigoError && e.mensaje) {
              toast.error(`Error al crear Producto. ${e.mensaje}`);
              setIsLoading(false);
              return;
            }
            toast.error("Error al crear Producto.");
            setIsLoading(false);
          });

        setIsLoading(false);
        toast.dismiss(toastId);

        if (!response) return;

        toast.success("Producto creado.");
        reloadProducto();

        buttonCancelModalRef.current.click();
      } else {
        //productImagePathsString

        /*const valuesToSend = values.facilities.filter((facility, i) => {
            // Let's send only those that have just been disabled or enabled:
            return facility.enabled !== initialValues[i].enabled;
          }).map((facility) => ({
            key: facility.facilityName,
            value: facility.enabled
          }));*/

        var result = {};
        var keys = Object.keys(initialValues);

        for (var key in values) {
          if (keys.includes(key) && values[key] !== initialValues[key]) {
            result[key] = values[key];
          }
        }

        /*  const valuesToSend = values.filter((item, i, original) => {
            // Let's send only those that have just been disabled or enabled:
            //return item.enabled !== initialValues[i].enabled;
            return item !== initialValues[i].enabled;
          });*/

        /*.map((facility) => ({
            key: facility.facilityName,
            value: facility.enabled
          }));*/

        const toastId = toast.loading("Actualizando Producto...");
        setIsLoading(true);

        const responseActivo = await api
          .activarProducto(values.id, values.activo)
          .catch((e) => {
            setIsLoading(false);
            toast.dismiss(toastId);
            toast.error("Error al actualizar activo Producto.");
          });

        //  if (!responseActivo) return;

        const response = await api
          .updateProducto(values.id, values)
          .catch((e) => {
            toast.dismiss(toastId);
            if (e.esError && e.codigoError && e.mensaje) {
              toast.error(`Error al actualizar Producto. ${e.mensaje}`);
              setIsLoading(false);
              return;
            }
            toast.error("Error al actualizar Producto.");
            setIsLoading(false);
          });
        if (!response) return;

        toast.dismiss(toastId);
        setIsLoading(false);

        buttonCancelModalRef.current.click();

        toast.dismiss(toastId);
        toast.success("Producto actualizado.");
        reloadProducto();
      }
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      tagRef.current?.removeAll();
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  return (
    <>
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropCrearProducto"
        hidden
      >
        Abrir Crear Producto
      </button>

      <div
        className="modal fade modal-lg"
        id="staticBackdropCrearProducto"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropCrearProductoLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {createMode ? "Crear" : "Editar"} Producto
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <DragNdrop
                ref={dragDropRef}
                width="300px"
                height="400px"
                images={files}
              />
              <form
                className="row g-3"
                onSubmit={(event) => {
                  event.preventDefault();
                  return false;
                }}
              >
                <div className="form-control">
                  <h5>Información General</h5>

                  <div className="row">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Nombre
                      </label>
                      <input
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.nombre,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("nombre")}
                        {...formikExtra.upperCase("nombre", formik)}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.nombre}
                      </div>
                    </div>

                    <div className="col-2 align-container-center">
                      <div className="container-center-horizontal">
                        <div className="form-check form-switch container-center-vertical">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                            {...formik.getFieldProps("activo")}
                            checked={formik.values.activo}
                            disabled={
                              isActiveDisabled || !permissions.canActivar
                            }
                          />
                          <span>
                            <label
                              className="form-check-label"
                              htmlFor="flexSwitchCheckDefault"
                            >
                              Activo
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="validationApellidoPaterno"
                      className="form-label"
                    >
                      Descripción
                    </label>
                    <textarea
                      placeholder="Acerca del producto"
                      className="form-control"
                      ref={inputRef}
                      {...formik.getFieldProps("descripcion")}
                    />
                    <div className="valid-feedback"></div>
                    <div className="invalid-feedback">
                      {formik.errors.descripcion}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="validationApellidoPaterno"
                      className="form-label"
                    >
                      Tags
                    </label>
                    <div
                      id="example1"
                      className={`input form-control textarea ${stylesPro.tempura} `}
                      style={{}}
                    ></div>
                  </div>
                </div>

                <div className="form-control">
                  <h5>Precio</h5>
                  <div className="row">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Precio Costo
                      </label>
                      <div className="input-group">
                        <input
                          ref={withMask("currency", {
                            groupSeparator: ",",
                            digits: 0,
                            numericInput: true,
                            rightAlign: false,
                            allowMinus: false,
                          })}
                          type="text"
                          className={`form-control ${invalidClass(
                            formik.errors.precioCosto,
                          )}`}
                          id="validationName"
                          aria-describedby="emailHelp"
                          value={formik.values.precioCosto}
                          onChange={async (e) => {
                            const aValue = onlyNumbers(e.target.value);

                            formik.setFieldValue("precioCosto", aValue);
                          }}
                          disabled={createMode}
                        />
                        <UpDown upHandler={() => {}} downHandler={() => {}} />
                      </div>
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.precioCosto}
                      </div>
                    </div>

                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Precio Venta
                      </label>
                      <input
                        ref={withMask("currency", {
                          groupSeparator: ",",
                          digits: 0,
                          numericInput: true,
                          rightAlign: false,
                          allowMinus: false,
                        })}
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.precioVenta,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        value={formik.values.precioVenta}
                        onChange={async (e) => {
                          const aValue = onlyNumbers(e.target.value);

                          formik.setFieldValue("precioVenta", aValue);
                        }}
                        disabled={createMode}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.precioVenta}
                      </div>
                    </div>

                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Cantidad
                      </label>
                      <input
                        type="number"
                        className={`form-control ${invalidClass(
                          formik.errors.cantidad,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("cantidad")}
                        disabled={createMode}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.cantidad}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-control">
                  <h5>Inventario</h5>

                  <div className="row">
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        SKU
                      </label>
                      <input
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.sku,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("sku")}
                        readOnly
                        disabled
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.sku}
                      </div>
                    </div>

                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Codigo de Barras
                      </label>
                      <input
                        type="text"
                        className={`form-control ${invalidClass(
                          formik.errors.codigoBarras,
                        )}`}
                        id="validationName"
                        aria-describedby="emailHelp"
                        {...formik.getFieldProps("codigoBarras")}
                        {...formikExtra.upperCase("codigoBarras", formik)}
                      />
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.codigoBarras}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-control">
                  <h5>Características SKU</h5>

                  <div className="row">
                    <div className="col">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Marca
                      </label>
                      <select
                        className={`form-select ${invalidClass(
                          formik.errors.marcaId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("marcaId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "marcaId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {marcas.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.marcaId}
                      </div>
                    </div>
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Genero
                      </label>

                      <select
                        className={`form-select ${invalidClass(
                          formik.errors.generoId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("generoId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "generoId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {generos.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.generoId}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col ">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Tamaño
                      </label>
                      <select
                        className={`form-select ${invalidClass(
                          formik.errors.tamañoId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("tamañoId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "tamañoId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {tamaños.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.tamañoId}
                      </div>
                    </div>
                    <div className="col align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Concentración
                      </label>

                      <select
                        className={`form-select ${invalidClass(
                          formik.errors.concentracionId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("concentracionId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "concentracionId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {concentraciones.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback">Looks good! WPWPWPW</div>
                      <div className="invalid-feedback">
                        {formik.errors.concentracionId}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Presentación
                      </label>
                      <select
                        className={`form-select ${invalidClass(
                          formik.errors.presentacionId,
                        )}`}
                        id="inputGroupSelect01"
                        {...formik.getFieldProps("presentacionId")}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "presentacionId",
                            parseInt(e.target.value),
                          );
                        }}
                      >
                        {presentaciones.map((item) => (
                          <option value={item.id}>{item.nombre}</option>
                        ))}
                      </select>
                      <div className="valid-feedback"></div>
                      <div className="invalid-feedback">
                        {formik.errors.presentacionId}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cancelar
                  </button>
                  <LoadingButton
                    style={{ height: "38px" }}
                    onClick={(e) => {
                      formik.handleSubmit();
                    }}
                    text={"Guardar"}
                    loadingText={"Guardando..."}
                    isLoading={isLoading}
                    hidden={!permissions.canEdit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default CreateProduct;
